<template>
  <div class="x-tablelist-view" data-automation="group">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @search="search"
      @input="search"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addChannel from './template/addChannel';
import changeChannel from './template/changeChannel';
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          hideBtn: true,
          placeholder: this.$t('HT.rules.channel.name')
        },
        {
          type: 'input',
          key: 'code',
          hideBtn: true,
          placeholder: this.$t('HT.rules.channel.code')
        },
        {
          type: 'select',
          key: 'type',
          options: [
            {
              label: this.$t('HT.options.channelType1'),
              value: 'SMS'
            },
            {
              label: this.$t('HT.options.messageType3'),
              value: 'TTS'
            }
          ],
          placeholder: this.$t('HT.addChannel.type'),
          event: 'change'
        },
        {
          type: 'select',
          key: 'disabled',
          options: this.$opt.channelStatus,
          placeholder: this.$t('HT.appSendLimit.disableType'),
          event: 'change'
        },
        {
          type: 'button',
          text: this.$t('HT.search1'),
          show: true,
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.channelManagement.add'),
          right: true,
          hidden: !this.$hasModule(36),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据

        {
          label: this.$t('HT.addChannel.name'),
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.addChannel.code'),
          prop: 'code',
          tooltip: true
        },
        {
          label: this.$t('HT.addChannel.type'),
          tooltip: true,
          prop: 'type',
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.channelType);
          }
        },
        {
          label: this.$t('HT.changeChannel.priority'),
          prop: 'priority',
          tooltip: true
        },
        {
          label: this.$t('HT.orderManage.status'),
          prop: 'disabled',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.channelStatus);
          }
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(36),
          width: 180,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [
                  this.$t('HT.addChannel.open'),
                  this.$t('HT.addChannel.close'),
                  this.$t('HT.edit2'),
                  this.$t('HT.delete')
                ],
                className: [
                  params.disabled ? '' : 'no-click',
                  !params.disabled ? '' : 'no-click',
                  '',
                  ''
                ],
                colors: ['#0087ff', '#f45c5c', '#0087ff', '#f45c5c'],
                event: ['start', 'disabled', 'toChange', 'del']
              },
              on: {
                start: () => {
                  const startData = { code: params.code, disabled: false };
                  this.changeStatus(startData);
                },
                disabled: () => {
                  const disabledData = { code: params.code, disabled: true };
                  this.changeStatus(disabledData);
                },
                toChange: () => {
                  const title = this.$t('HT.channelManagement.edit');
                  this.$uxModal.show({
                    title,
                    content: (h) => {
                      return h(changeChannel, {
                        props: {
                          data: params
                        }
                      });
                    },
                    confirm: (data) => {
                      data.priority = data.priority - 0; //转成number
                      this.changeChannel(data);
                    }
                  });
                },
                del: () => {
                  const title = this.$t('HT.channelManagement.del');
                  const content = this.$t('HT.channelManagement.del.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: null, // 分组名称
        code: null, // 通道编码
        type: null, // 通道类型
        disabled: null, // 是否禁用
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.message.getChannel(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addChannel(params) {
      this.$uxLoading.show();
      this.$api.message.addChannel(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('添加成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    changeChannel(params) {
      let data = JSON.parse(JSON.stringify(params));
      data.type = data.type === '短信SMS' ? 'SMS' : 'TTS';
      this.$uxLoading.show();
      this.$api.message.changeChannel(data).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('修改成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 修改审批状态
     * @param {Object} params 表单提交参数
     */
    changeStatus(params) {
      this.$uxLoading.show();
      this.$api.message.changeChannel(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          params.disabled
            ? this.$uxMessage.success('禁用成功')
            : this.$uxMessage.success('启用成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(params) {
      this.$uxLoading.show();
      this.$api.message.delChannel(params.id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('删除成功');
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新建分组弹窗
     */
    showAdd() {
      this.$uxModal.show({
        title: '添加通道',
        content: (h) => {
          return h(addChannel);
        },
        confirm: (params) => {
          params.priority = params.priority - 0;
          this.addChannel(params);
        }
      });
    },

    /**
     * 点击搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变分组名称
     */
    change() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
